import * as React from "react";
import { forwardRef } from "react";
const SvgNextStep = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M7.25 0h1.5v7.25H16v1.5H7.25V0Z" }))));
const ForwardRef = forwardRef(SvgNextStep);
export default ForwardRef;
